import Vue from 'vue'
import Router from 'vue-router'
import zcorganDetails from '@/crowd_fund/organDetails'
import zccertificate from '@/crowd_fund/certificate'
import zccertificateTrain from '@/crowd_fund/certificate_train'
import zcprojectDetail from '@/crowd_fund/projectDetail'
import zcprojectList from '@/crowd_fund/projectList'
import zchelphe from '@/crowd_fund/helpHe'
import dTList from '@/crowd_fund/dTList'
import dTPublish from '@/crowd_fund/dTPublish'
import dTEdit from '@/crowd_fund/dTEdit'
import dTDetail from '@/crowd_fund/dTDetail'
import dTRankStaff from '@/crowd_fund/dTRankStaff'
import dTRankCompany from '@/crowd_fund/dTRankCompany'
import bindMobile from '@/crowd_fund/bindMobile'
import zcrecdetail from '@/crowd_fund/zcrec_detail'
import poverty from '@/crowd_fund/povertyAlleviation'
import povertySearch from '@/crowd_fund/povertyAlleviationSearch'
import mainList from '@/crowd_fund/socialOrgan/mainList'
import needsDetail from '@/crowd_fund/socialOrgan/needsDetail'
import projectsDetail from '@/crowd_fund/socialOrgan/projectsDetail'
import successDetail from '@/crowd_fund/socialOrgan/successDetail'
import zcnewsList from '@/crowd_fund/newsList'
import active1017 from '@/crowd_fund/active1017/active1017'
import dockingList from '@/crowd_fund/docking/dockingList'
Vue.use(Router)

export default new Router({
  routes: [
      {
          path:'*',
          redirect:'/'
      },
      {
          path: '/',
          name: 'zcprojectList',
          component: zcprojectList
      },
      {
          path: '/zcorganDetails/:org_user_id/:id/:zcuserid/:zcnickname/:zctoken',
          name: 'zcorganDetails',
          component: zcorganDetails
      },
      {
          path: '/zccertificate/:acr002/:donateTime/:projectId/:zcuserid/:zctoken/:zcnickname/:zcmoney/:zcfoundation',
          name: 'zccertificate',
          component: zccertificate
      },
      {
          path: '/zccertificateTrain/:acr002/:donateTime/:projectId/:zcuserid/:zctoken/:zcnickname/:zcmoney/:zcfoundation/:orderno',
          name: 'zccertificateTrain',
          component: zccertificateTrain
      },
      {
          path: '/zcprojectDetail/:id/:zcuserid/:zcnickname/:zctoken',
          name: 'zcprojectDetail',
          component: zcprojectDetail
      },
      {
        path: '/zcnewsList',
        name: 'zcnewsList',
        component: zcnewsList
      },
      {
          path: '/zcprojectList/:zcuserid/:zcnickname/:zctoken',
          name: 'zcprojectList',
          component: zcprojectList
      },
      {
          path: '/zchelphe/:id/:sum/:acr002/:zcuserid/:zctoken/:zcnickname/:isDt/:dtId/:epId/:foundation',
          name: 'zchelphe',
          component: zchelphe
      },
      {
        path:'/dTList/:userId/:epId/:token/:nickName',///:userId/:epId/:token/:nickName
        name: 'dTList',
        component: dTList
      },
      {
        path:'/dTPublish/:acr001/:epId',
        name: 'dTPublish',
        component: dTPublish
      },
      {
        path:'/dTDetail/:dtId/:acr001/:epId/:isShare',
        name: 'dTDetail',
        component: dTDetail
      },{
        path: '/dTRankStaff/:orgName/:dtId/:epId/:acr001',
        name: 'dTRankStaff',
        component: dTRankStaff
      },{
        path: '/dTRankCompany/:acr001',
        name: 'dTRankCompany',
        component: dTRankCompany
      },
      {
        path:'/dTEdit/:acr001/:epId',
        name: 'dTEdit',
        component: dTEdit,
        meta:{
          isUseCache: false,
          keepAlive: true
        }
      },
      {
        path:'/bindMobile/:acr001',
        name:'bindMobile',
        component:bindMobile
      },
      {
        path:'/zcrecdetail/:id/:projectid',
        name:'zcrecdetail',
        component:zcrecdetail
      },
      {
        path: '/poverty/:userid/:nickname/:token',
        name:'poverty',
        component:poverty
      },
      {
        path: '/povertySearch/:userid/:nickname/:token',
        name:'povertySearch',
        component:povertySearch
      },
      {
        path: '/dockingList/:zcuserid/:zcnickname/:zctoken',
        name:'dockingList',
        component:dockingList
      },
      {
        path: '/mainList',
        name:'mainList',
        component:mainList
      },
      {
        path: '/needsDetail',
        name:'needsDetail',
        component:needsDetail,
      },
      {
        path: '/projectsDetail',
        name:'projectsDetail',
        component:projectsDetail,
      },
      {
        path: '/successDetail',
        name:'successDetail',
        component:successDetail,
      },
      {
        path: '/active1017',
        name: 'active1017',
        component: active1017
      },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js